export default __webpack_public_path__ + "static/media/networkHighlight.b4e4ac78.svg";